const ModalConfigurationWrapper = (NativeComponent) => ({ adminConfig }) => {
  const { isVisible } = adminConfig.parameters;
  if (!isVisible) {
    return null;
  }
  return NativeComponent;
};

export default ModalConfigurationWrapper;
